import React from 'react'
import PropTypes from 'prop-types'
import { ETF_INDEX_FUND } from '../../Helpers/FundTypes'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'
import {
  getMutualFundTooltipContent,
  getTooltipContentByKey,
} from '../../../Tooltip/tooltipUtil'
import Tooltip from '../../../Tooltip/Tooltip.jsx'

function PortfolioCharacteristics({ portfolioCharsDetails, fundGroup }) {
  const { portfolioCharEffDate, primaryIndexName, portfolioCharacteristics } =
    portfolioCharsDetails

  return (
    <div className="u-marginTop0" id="portfolio-characteristics-details">
      <div className="Grid Grid--alignMiddle">
        <div className="Content u-paddingRight2gu u-sizeFill">
          <h3>
            {renderSectionTitle(fundGroup)}{' '}
            {renderPrimaryIndex(primaryIndexName)}{' '}
            <span className="u-sm-block u-sm-paddingTop1gu">
              as of {formatDateStandard(portfolioCharEffDate)}
            </span>
          </h3>
        </div>
        <div className="u-sizeFit">
          <a
            className="js-subnav-link Link u-textSecondary u-textSolid"
            href="#definitions"
          >
            View definitions
          </a>
        </div>
      </div>

      <div className="Grid Grid--alignBottom Grid--fill Grid--withGutter">
        {renderPortfolioCharacteristics(portfolioCharacteristics, fundGroup)}
      </div>
    </div>
  )
}
function renderSectionTitle(fundGroup) {
  return fundGroup === ETF_INDEX_FUND
    ? 'Index Statistics'
    : 'Portfolio Characteristics**'
}

function renderPrimaryIndex(primaryIndexName) {
  if (primaryIndexName) {
    return `vs. ${primaryIndexName}`
  }
}

function renderValueComparison(character, fundGroup) {
  let valueDisplay = character.fundValue || ''

  if (character.indexValue) {
    return fundGroup === ETF_INDEX_FUND
      ? character.indexValue
      : `${valueDisplay} vs. ${character.indexValue}`
  } else {
    return valueDisplay
  }
}

function renderPortfolioCharacteristics(portfolioCharacteristics, fundGroup) {
  const mutualFundTooltipData = getMutualFundTooltipContent()

  return portfolioCharacteristics.map((character) => {
    let valueDisplay = renderValueComparison(character, fundGroup)

    if (character.code === 'DIVIDEND_YIELD') {
      character.description = 'Index Dividend Yield (%)'
    }

    return (
      <div
        className="u-sm-paddingTop3gu u-sm-size6of12 u-sm-posRelative"
        key={character.description}
      >
        {getTooltipContentByKey(mutualFundTooltipData, character.description)
          ?.heading ||
        getTooltipContentByKey(mutualFundTooltipData, character.description)
          ?.content ? (
          <Tooltip
            heading={
              getTooltipContentByKey(
                mutualFundTooltipData,
                character.description
              )?.heading || ''
            }
            content={
              getTooltipContentByKey(
                mutualFundTooltipData,
                character.description
              )?.content || ''
            }
            direction="Tooltip-left"
            id={`tooltip-${character.description}`}
          >
            <p className="u-textColorLight u-textSecondary u-textSolid">
              <span className="u-textColorLight u-textSecondary Tooltip-label">
                {character.description}
              </span>
              <span className="Icon--material Tooltip-icon u-marginLeft1gu u-inline">
                info
              </span>
            </p>
          </Tooltip>
        ) : (
          <p className="u-textColorLight u-textSecondary u-textSolid">
            {character.description}
          </p>
        )}
        <p className="u-textSizeMsrp3 u-textSecondary u-sm-paddingTop0 u-sm-textSizeMsrp1">
          {valueDisplay}
        </p>
      </div>
    )
  })
}

PortfolioCharacteristics.propTypes = {
  portfolioCharsDetails: PropTypes.object,
  fundGroup: PropTypes.string,
}

export default PortfolioCharacteristics
